/**
 * @generated SignedSource<<f4327084d715920bc2692a1e1b5fe528>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductImage_item$data = {
  readonly localizedPdpUrl: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "ProductImage_item";
};
export type ProductImage_item$key = {
  readonly " $data"?: ProductImage_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductImage_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductImage_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "localizedPdpUrl",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "fab432cfd60d7dd23c5df39eac4d1cfe";

export default node;
